let API_link = "https://api.barbermate.eu"

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    API_link = "https://127.0.0.1:8000";
    // API_link = "http://192.168.0.187:8000";
}

export const URL = API_link
export const IMAGE_URL = API_link
